module.exports = __webpack_public_path__ + "img/banner_v1.0657584.png";